import { Component } from '@angular/core';

@Component({
  selector: 'app-public-area',
  template: `<app-public-area-canvas>
               <router-outlet></router-outlet>
             </app-public-area-canvas>`
})
export class PublicAreaComponent {

  constructor() { }
}